import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import OTPModal from '../components/OTPModal';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [otpOpen, setOtpOpen] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState('');
  const [accessCode, setAccessCode] = useState('');

  const submitEmail = async (e) => {
    e?.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) { setErr('Enter a valid email'); return; }
    setBusy(true);
    setErr(null);
    setVerifiedEmail(email.trim());
    setOtpOpen(true);
    setBusy(false);
  };

  return (
    <div className="relative min-h-screen font-body bg-[#0B0A08] text-white flex flex-col">
      <header className="px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/landing" className="flex items-center gap-2">
          <img src="/assets/logo.png" alt="" className="h-7 w-auto" />
          <span className="font-logo tracking-[0.28em] text-[15px]">MYARC</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-5">
        <div className="w-full max-w-[440px] panel-strong p-7 md:p-9 rounded-2xl fade-up">
          <div className="text-center">
            <div className="chip mx-auto inline-flex" style={{ borderColor: 'rgba(199,164,109,0.35)', color: '#C7A46D' }}>Sign in</div>
            <h1 className="mt-4 font-head text-[26px] md:text-[30px]" style={{ color: '#C7A46D' }}>Welcome to MYARC.</h1>
            <p className="mt-2 text-white/60 text-[14px] leading-[1.7]">Life OS is private while MYARC is in tester mode. Use your email and tester access code.</p>
          </div>

          <form onSubmit={submitEmail} className="space-y-3">
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"/>
              <input className="input pl-9" type="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <input
              className="input"
              type="text"
              autoComplete="one-time-code"
              placeholder="Tester access code"
              value={accessCode}
              onChange={e => setAccessCode(e.target.value)}
            />
            {err && <div className="text-[12.5px]" style={{ color: '#e05252' }}>{err}</div>}
            <button disabled={busy} className="btn btn-primary w-full justify-center py-3">{busy ? 'Opening code screen...' : <>Send sign-in code <ArrowRight size={14}/></>}</button>
          </form>
          <div className="mt-4 text-center text-[12px] text-white/45">No access code yet? Complete the Brain Scan and join the waitlist.</div>
        </div>
      </main>
      <OTPModal
        open={otpOpen}
        email={verifiedEmail}
        accessCode={accessCode}
        onClose={() => setOtpOpen(false)}
        onSuccess={(user) => {
          setOtpOpen(false);
          if (user?.life_os_access) navigate('/app');
          else navigate('/waitlist', { state: { email: verifiedEmail, lifeOsPrivate: true } });
        }}
      />
    </div>
  );
}
